module.exports = __webpack_public_path__ + "img/aspi.31d48480.png";